import React, { use } from 'react';
import LogoDark from '../assets/images/logo_dark.svg';
import LogoLight from '../assets/images/logo_light.svg';
import '../assets/css/navbar.css';
import { Button, useTheme, Box, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ text, showSignin, mobileComponent }) => {
  const theme = useTheme();

  const logo = theme.palette.mode === 'dark' ? LogoDark : LogoLight;
  const { isLogin } = useAuth();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const navigate = useNavigate();
  return (
    <div className="nav">
      {mobileComponent != null && mobileComponent}
      <Box
        component="img"
        src={logo}
        alt="logo"
        draggable="false"
        sx={{
          paddingTop: '10px',
          paddingLeft: mobileComponent != null ? '40px' : '15px',
          height: {
            xs: '50px',
            sm: '50px',
            md: '60px',
            lg: '60px',
            xl: '60px',
          },
          width: 'auto',
          cursor: 'pointer',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
        }}
        onClick={() => navigate('/home/Home')}
      />
      {showSignin && (
        <Button
          variant="contained"
          size={isMobile ? 'small' : 'large'}
          color="secondary"
          sx={{
            paddingTop: {
              xs: '5px',
              sm: '5px',
              md: '10px',
            },
            borderRadius: {
              xs: '20px',
              sm: '40px',
              md: '60px',
            },
            textTransform: 'none',
            mr: 2,
          }}
          onClick={() => {
            if (isLogin) navigate('/chat');
            else navigate('/signin', { replace: true });
          }}
        >
          {isLogin ? 'Get Started' : 'Sign In'}
        </Button>
      )}
      {text && (
        <div className="nav-text">
          <h3>{text}</h3>
        </div>
      )}
    </div>
  );
};

export default Navbar;
